export default __webpack_public_path__ + "static/Clint-9548feff79e3f25dc4987140108bae3c.jpg";